const TextSnippet = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M200-80q-33 0-56.5-23.5T120-160v-640q0-33 23.5-56.5T200-880h400l240 240v480q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H560v-200H200v600Zm80-120h400v-80H280v80Zm0-320h200v-80H280v80Zm0 160h400v-80H280v80Zm-80-280v200-200 600-600Z" />
        </svg>
    )
}

export default TextSnippet;

